import MESSAGES from 'core/data-model/constants/bi-messages'

import { getMCIExceptionNotes, getMCIExplanationNotes } from 'core/service/rider/benefits/exception-notes'
import { getRiderPlanCode } from 'core/service/rider/rider-mci'
import { buildHeaderTable } from 'core/service/pdf-generation/utils/builder'
import { findDataOnListByRiderCode } from 'quick-quote/product-common/benefit-illustration/components/rider-benefits/components/mci-rider-benefit'

const headers = [
  MESSAGES.BENEFIT_TITLE,
  MESSAGES.BENEFIT_BAHT,
  MESSAGES.RIDER_BENEFIT_DAY_OR_TIME,
  MESSAGES.RIDER_TOTAL_BENEFIT_BAHT_HAVE_STAR,
]

export const MCIBenefitSection = ({ rider, riderBenefitData, showDisclaimer, insured }) => {
  const planCode = getRiderPlanCode(rider, insured.age)
  const { headTitle, headSubTitle } = riderBenefitData
  return [
    { text: `${headTitle}`, style: 'sub-title' },
    { text: `${headSubTitle}`, style: 'sub-title' },
    ...buildBenefitSection(riderBenefitData, planCode, insured.age),
    ...buildEndorseSection(riderBenefitData, planCode),
    ...buildDisclaimer(showDisclaimer),
    { ...buildExceptionNotes() },
  ]
}
const buildBenefitSection = (riderBenefitData, planCode, insured) => {
  const { benefits } = riderBenefitData
  return [
    {
      text: `${benefits.title} ${findDataOnListByRiderCode(benefits.titlePlan, planCode)}`,
      style: 'sub-title',
    },
    {
      table: buildTopRiderBenefitTable(riderBenefitData, planCode),
      layout: 'lightBorder',
      style: 'table',
      marginBottom: -1,
    },
    {
      table: buildBenefitTable(riderBenefitData, planCode),
      layout: 'lightBorder',
      style: 'table',
    },
    {
      text: benefits.remark.remark_1,
      style: 'disclaimer',
    },
    {
      text: insured.value < 11 ? benefits.remark.remark_2 : '',
      style: 'disclaimer',
    },
  ]
}

const buildTopRiderBenefitTable = (riderBenefitData, planCode) => {
  const { maxBenefitPerAnnualPolicy, maxBenefitPerPolicy, numberDiseaseCoverage } = riderBenefitData
  return {
    headerRows: 0,
    widths: ['*', 80],
    dontBreakRows: true,
    body: [
      [
        { text: `${numberDiseaseCoverage.title}`, alignment: 'center', bold: true },
        {
          text: `${findDataOnListByRiderCode(numberDiseaseCoverage.benefit, planCode)}`,
          alignment: 'center',
          bold: true,
        },
      ],
    ],
  }
}

const buildBenefitTable = (riderBenefitData, planCode) => {
  const { maxBenefitPerAnnualPolicy, maxBenefitPerPolicy, benefits } = riderBenefitData
  const { contents } = benefits

  return {
    headerRows: 1,
    widths: ['*', 80, 75, 80],
    dontBreakRows: true,
    body: [
      buildHeaderTable(headers),
      // subject 1
      [{ text: `${contents.subject_1}`, alignment: 'left', bold: true, colSpan: 4 }],
      // 1
      [
        {
          stack: [
            {
              text: `${contents.group_1.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_1.title[0]}\n     ${contents.group_1.title[1]}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${findDataOnListByRiderCode(contents.group_1.benefit, planCode)}`, alignment: 'center' },
        { text: `${contents.group_1.totalTimes}`, alignment: 'center' },
        {
          text: `${findDataOnListByRiderCode(
            maxBenefitPerAnnualPolicy.benefit,
            planCode
          )}\nต่อรอบปี\nกรมธรรม์ประกันภัย\n${findDataOnListByRiderCode(
            maxBenefitPerPolicy.benefit,
            planCode
          )}\nตลอดอายุของ\nผู้เอาประกันภัยที่มีการรับประกันภัยนี้`,
          alignment: 'center',
          rowSpan: 5,
        },
      ],
      // 2
      [
        {
          stack: [
            {
              text: `${contents.group_2.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_2.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
          colSpan: 3,
        },
        '',
        '',
        '',
      ],
      [
        {
          text: `${contents.group_2_1.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_2_1.benefit}`, alignment: 'center' },
        { text: `${contents.group_2_1.totalTimes}`, alignment: 'center' },
        '',
      ],
      [
        {
          text: `${contents.group_2_2.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_2_2.benefit}`, alignment: 'center' },
        { text: `${contents.group_2_2.totalTimes}`, alignment: 'center' },
        '',
      ],
      [
        {
          text: `${contents.group_2_3.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_2_3.benefit}`, alignment: 'center' },
        { text: `${contents.group_2_3.totalTimes}`, alignment: 'center' },
        '',
      ],
      [
        {
          text: `${contents.group_2_4.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_2_4.benefit}`, alignment: 'center' },
        { text: `${contents.group_2_4.totalTimes}`, alignment: 'center' },
        { text: '', rowSpan: 14 },
      ],
      // 3
      [
        {
          stack: [
            {
              text: `${contents.group_3.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_3.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${contents.group_3.benefit}`, alignment: 'center' },
        { text: `${contents.group_3.totalTimes}`, alignment: 'center' },
        '',
      ],
      // 4
      [
        {
          stack: [
            {
              text: `${contents.group_4.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_4.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
          colSpan: 3,
        },
        '',
        '',
        '',
      ],
      [
        {
          text: `${contents.group_4_1.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_4_1.benefit}`, alignment: 'center' },
        { text: `${contents.group_4_1.totalTimes}`, alignment: 'center' },
        '',
      ],
      [
        {
          text: `${contents.group_4_2.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_4_2.benefit}`, alignment: 'center' },
        { text: `${contents.group_4_2.totalTimes}`, alignment: 'center' },
        '',
      ],
      [
        {
          text: `${contents.group_4_3.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_4_3.benefit}`, alignment: 'center' },
        { text: `${contents.group_4_3.totalTimes}`, alignment: 'center' },
        '',
      ],
      [
        {
          text: `${contents.group_4_4.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_4_4.benefit}`, alignment: 'center' },
        { text: `${contents.group_4_4.totalTimes}`, alignment: 'center' },
        '',
      ],
      [
        {
          text: `${contents.group_4_5.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_4_5.benefit}`, alignment: 'center' },
        { text: `${contents.group_4_5.totalTimes}`, alignment: 'center' },
        '',
      ],
      // 5
      [
        {
          stack: [
            {
              text: `${contents.group_5.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_5.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${contents.group_5.benefit}`, alignment: 'center' },
        { text: `${contents.group_5.totalTimes}`, alignment: 'center' },
        '',
      ],
      // subject 2
      [{ text: `${contents.subject_2}`, alignment: 'left', bold: true, colSpan: 3 }],
      // 6
      [
        {
          stack: [
            {
              text: `${contents.group_6.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_6.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
          colSpan: 3,
        },
        '',
        '',
        '',
      ],
      [
        {
          text: `${contents.group_6_1.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_6_1.benefit}`, alignment: 'center' },
        { text: `${contents.group_6_1.totalTimes}`, alignment: 'center' },
        '',
      ],
      [
        {
          text: `${contents.group_6_2.title}`,
          alignment: 'left',
        },
        { text: `${contents.group_6_2.benefit}`, alignment: 'center' },
        { text: `${contents.group_6_2.totalTimes}`, alignment: 'center' },
        '',
      ],
      // 7
      [
        {
          stack: [
            {
              text: `${contents.group_7.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_7.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${contents.group_7.benefit}`, alignment: 'center' },
        { text: `${contents.group_7.totalTimes}`, alignment: 'center' },
        '',
      ],
      // 8
      [
        {
          stack: [
            {
              text: `${contents.group_8.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_8.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${findDataOnListByRiderCode(contents.group_8.benefit, planCode)}`, alignment: 'center' },
        { text: `${findDataOnListByRiderCode(contents.group_8.totalTimes, planCode)}`, alignment: 'center' },
        { text: '', rowSpan: 6 },
      ],
      // 9
      [
        {
          stack: [
            {
              text: `${contents.group_9.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_9.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${contents.group_9.benefit}`, alignment: 'center' },
        { text: `${contents.group_9.totalTimes}`, alignment: 'center' },
        '',
      ],
      // 10
      [
        {
          stack: [
            {
              text: `${contents.group_10.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_10.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${contents.group_10.benefit}`, alignment: 'center' },
        { text: `${contents.group_10.totalTimes}`, alignment: 'center' },
        '',
      ],
      // 11
      [
        {
          stack: [
            {
              text: `${contents.group_11.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_11.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${contents.group_11.benefit}`, alignment: 'center' },
        { text: `${contents.group_11.totalTimes}`, alignment: 'center' },
        '',
      ],
      // 12
      [
        {
          stack: [
            {
              text: `${contents.group_12.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_12.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${contents.group_12.benefit}`, alignment: 'center' },
        { text: `${contents.group_12.totalTimes}`, alignment: 'center' },
        '',
      ],
      // 13
      [
        {
          stack: [
            {
              text: `${contents.group_13.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_13.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${contents.group_13.benefit}`, alignment: 'center' },
        { text: `${contents.group_13.totalTimes}`, alignment: 'center' },
        '',
      ],
      // footer
      [{ text: 'การมีส่วนร่วมจ่าย', alignment: 'left', bold: true, decoration: 'underline', colSpan: 4 }],
      [
        { text: `${contents.deduct_copay.deduct.title}`, alignment: 'left' },
        { text: `${contents.deduct_copay.deduct.benefit}`, alignment: 'center', colSpan: 3 },
      ],
      [
        { text: `${contents.deduct_copay.copay.title}`, alignment: 'left' },
        { text: `${contents.deduct_copay.copay.benefit}`, alignment: 'center', colSpan: 3 },
      ],
    ],
  }
}

export const buildEndorseSection = (riderBenefitData, planCode) => {
  const { endorse } = riderBenefitData
  return [
    {
      text: `${endorse.title} ${findDataOnListByRiderCode(endorse.titlePlan, planCode)}`,
      style: 'sub-title',
      pageBreak: 'before',
    },
    {
      table: buildEndorseTable(riderBenefitData, planCode),
      layout: 'lightBorder',
      style: 'table',
    },
    {
      text: endorse.remark.remark_1,
      style: 'disclaimer',
    },
    {
      text: !['MCI1J', 'MCI1S'].includes(planCode) ? endorse.remark.remark_2 : '',
      style: 'disclaimer',
    },
  ]
}

const buildEndorseTable = (riderBenefitData, planCode) => {
  const { maxBenefitPerAnnualPolicy, maxBenefitPerPolicy, endorse } = riderBenefitData
  const { contents } = endorse

  return {
    headerRows: 1,
    widths: [268, 80, 75, 80],
    dontBreakRows: true,
    body: [
      buildHeaderTable(headers),
      // 14
      [
        {
          stack: [
            {
              text: `${contents.group_14.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_14.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${findDataOnListByRiderCode(contents.group_14.benefit, planCode)}`, alignment: 'center' },
        { text: `${findDataOnListByRiderCode(contents.group_14.totalTimes, planCode)}`, alignment: 'center' },
        ['MCI1J', 'MCI1S'].includes(planCode)
          ? { text: '-', alignment: 'center', rowSpan: 3 }
          : {
              text: `${findDataOnListByRiderCode(
                maxBenefitPerAnnualPolicy.benefit,
                planCode
              )}\nต่อรอบปี\nกรมธรรม์ประกันภัย
                 ${findDataOnListByRiderCode(
                   maxBenefitPerPolicy.benefit,
                   planCode
                 )}\nตลอดอายุของ\nผู้เอาประกันภัยที่มีการรับประกันภัยนี้`,
              alignment: 'center',
              rowSpan: 3,
            },
      ],
      // 15
      [
        {
          stack: [
            {
              text: `${contents.group_15.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_15.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${findDataOnListByRiderCode(contents.group_15.benefit, planCode)}`, alignment: 'center' },
        { text: `${contents.group_15.totalTimes}`, alignment: 'center' },
        '',
      ],
      // 16
      [
        {
          stack: [
            {
              text: `${contents.group_16.title_group}`,
              alignment: 'left',
              bold: true,
            },
            {
              text: `             ${contents.group_16.title}`,
              alignment: 'left',
              bold: false,
              preserveLeadingSpaces: true,
              marginTop: -16,
            },
          ],
        },
        { text: `${findDataOnListByRiderCode(contents.group_16.benefit, planCode)}`, alignment: 'center' },
        { text: `${contents.group_16.totalTimes}`, alignment: 'center' },
        '',
      ],

      // footer
      [{ text: 'การมีส่วนร่วมจ่าย', alignment: 'left', bold: true, decoration: 'underline', colSpan: 4 }],
      [
        { text: `${contents.deduct_copay.deduct.title}`, alignment: 'left' },
        { text: `${contents.deduct_copay.deduct.benefit}`, alignment: 'center', colSpan: 3 },
      ],
      [
        { text: `${contents.deduct_copay.copay.title}`, alignment: 'left' },
        { text: `${contents.deduct_copay.copay.benefit}`, alignment: 'center', colSpan: 3 },
      ],
    ],
  }
}

const buildDisclaimer = (showDisclaimer) =>
  showDisclaimer ? `*${MESSAGES.DISCLAIMER_OVER_56_MUST_HAVE_MEDICAL_EXAM}` : ''

const buildExceptionNotes = () => {
  const exceptionNotes = getMCIExceptionNotes()
  const exceptionTitle = exceptionNotes.title
  const [
    normalCondition,
    firstException,
    secondException,
    thirdException,
    extendExceptionTitle,
    extendExceptionDesc,
    warningTitle,
    warningDesc,
  ] = exceptionNotes.exceptions

  return {
    pageBreak: 'before',
    stack: [
      {
        text: `${exceptionTitle}`,
        style: 'sub-title-2',
        margin: [0, 0, 0, 5],
      },
      {
        text: `${normalCondition}`,
        style: 'sub-title-2',
        margin: [0, 0, 0, 5],
      },
      {
        ol: [
          firstException,
          secondException,
          {
            stack: [
              thirdException[0],
              thirdException[1],
              {
                table: {
                  body: [
                    ['(1)', { text: `${thirdException[2][0]}`, margin: [-5, 0, 0, 0] }],
                    ['(2)', { text: `${thirdException[2][1]}`, margin: [-5, 0, 0, 0] }],
                  ],
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 0],
              },
            ],
          },
        ],
        margin: [0, 0, 0, 5],
      },
      {
        text: `${extendExceptionTitle}`,
        style: 'sub-title-2',
        margin: [0, 0, 0, 5],
      },
      {
        text: `${extendExceptionDesc[0]}`,
        decoration: 'underline',
      },
      {
        text: `${extendExceptionDesc[1]}`,
      },
      {
        ol: [...extendExceptionDesc[2]],
        margin: [0, 0, 0, 5],
      },
      {
        text: `${warningTitle}`,
        style: 'sub-title-2',
        margin: [0, 0, 0, 5],
      },
      {
        text: `${warningDesc[0]}`,
      },
      {
        ol: [...warningDesc[1]],
        margin: [0, 0, 0, 5],
      },
    ],
  }
}

export const buildMCIExplanationNotes = (insured) => {
  const explanationNotes = getMCIExplanationNotes()
  const explanationTitle = explanationNotes.title
  const [
    note_1,
    [
      note_1_1,
      [note_1_1_1, note_1_1_2, note_1_1_3, note_1_1_4],
      note_1_2,
      note_1_3,
      note_1_4,
      note_1_5,
      note_1_6,
      note_1_7,
      [note_1_7_1, note_1_7_2, note_1_7_3],
      note_1_8,
      note_1_9,
      note_1_10,
      [note_1_10_1, note_1_10_2, note_1_10_3],
    ],
    note_2,
    [note_2_1, [note_2_1_1, note_2_1_2], note_2_2, note_2_3, note_2_4, [note_2_4_1, note_2_4_2, note_2_4_3]],
  ] = explanationNotes.explanations

  const boldOnlyDisease = (text) => [
    { text: text.split(')').slice(0, 1) + ')', bold: true },
    {
      text: text
        .split(')')
        .slice(1)
        .join(') '),
    },
  ]

  return {
    stack: [
      {
        text: `${explanationTitle}`,
        style: 'sub-title-2',
        margin: [0, 0, 0, 5],
      },
      {
        ol: [
          [
            { text: note_1, bold: true },
            {
              separator: ['1.'],
              ol: [
                [
                  ...boldOnlyDisease(note_1_1),
                  {
                    separator: ['(', ')'],
                    ol: [note_1_1_1, note_1_1_2, note_1_1_3, note_1_1_4],
                  },
                ],
                boldOnlyDisease(note_1_2),
                boldOnlyDisease(note_1_3),
                boldOnlyDisease(note_1_4),
                boldOnlyDisease(note_1_5),
                boldOnlyDisease(note_1_6),
                [
                  boldOnlyDisease(note_1_7),
                  {
                    separator: ['(', ')'],
                    ol: [note_1_7_1, note_1_7_2, note_1_7_3],
                  },
                ],
                boldOnlyDisease(note_1_8),
                boldOnlyDisease(note_1_9),
                [
                  boldOnlyDisease(note_1_10),
                  {
                    separator: ['(', ')'],
                    ol: [note_1_10_1, note_1_10_2],
                  },
                  {
                    text: note_1_10_3,
                  },
                ],
              ],
            },
          ],
          insured.age.value <= 10
            ? [
                [
                  {
                    text: note_2
                      .split(' ')
                      .slice(0, 2)
                      .join(' '),
                    bold: true,
                  },
                  {
                    text: note_2
                      .split(' ')
                      .slice(2)
                      .join(' '),
                  },
                ],
                {
                  separator: ['2.'],
                  ol: [
                    [
                      ...boldOnlyDisease(note_2_1),
                      {
                        separator: ['(', ')'],
                        ol: [note_2_1_1, note_2_1_2],
                      },
                    ],
                    boldOnlyDisease(note_2_2),
                    boldOnlyDisease(note_2_3),
                    [
                      ...boldOnlyDisease(note_2_4),
                      {
                        separator: ['(', ')'],
                        ol: [note_2_4_1, note_2_4_2],
                      },
                      {
                        text: note_2_4_3,
                      },
                    ],
                  ],
                },
              ]
            : [],
        ],
        margin: [0, 0, 0, 5],
      },
    ],
  }
}
